import styles from "./ProductCardHorizontal.module.scss";
import { useContext, useEffect, useState } from "react";
import axios from "../../config/axios";

//importing components
import { Select } from "antd";
import { BiMinus, BiPlus } from "react-icons/bi";
import {
  getVariantImage,
  getVariantPrice,
  percentageCalculator,
  sortVariantsByPrice,
} from "../../utils/helpers";
import { BsFillCartXFill } from "react-icons/bs";
import { CiImageOff } from "react-icons/ci";

//importing contexts
import { CartContext } from "../../Contexts/CartContext";
import { AuthContext } from "../../Contexts/AuthContext";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import { Link } from "react-router-dom";

const ProductCardHorizontal = ({
  product = {},
  discountOnly,
  singleVariant = false,
}) => {
  const cartContext = useContext(CartContext);
  const { user, isAuthenticated } = useContext(AuthContext);
  const { openSignIn } = useContext(AuthModalContext);

  // cheapest variant first
  const variants = sortVariantsByPrice(product.variants);

  const [selectedVariant, setSelectedVariant] = useState(
    product.variants ? variants[0] : product.variant
  );
  const [finalPrice, setFinalPrice] = useState(0.0);
  const [quantity, setQuantity] = useState(1);

  const [productInWishlist, setProductInWishlist] = useState(false);
  const [productInCart, setProductInCart] = useState(false);

  useEffect(() => {
    if (singleVariant) {
      setSelectedVariant(product.variant);
    } else {
      setSelectedVariant(sortVariantsByPrice(product.variants)[0]);
    }
  }, [product, singleVariant]);

  useEffect(() => {
    if (selectedVariant) {
      // console.log(getVariantPrice(selectedVariant))
      setFinalPrice(getVariantPrice(selectedVariant));
    }
  }, [selectedVariant]);

  useEffect(() => {
    // console.log('useEffect Triggered');
    setProductInCart(false);
    if (cartContext.cartItems) {
      for (let i = 0; i < cartContext.cartItems.length; i++) {
        if (cartContext.cartItems[i].id === product.id) {
          // console.log(cartContext.cartItems[i]);
          setProductInCart(true);
          setQuantity(cartContext.cartItems[i].quantity);
          break;
        }
      }
    }
  }, [...Object.values(cartContext)]);

  //defining increaseQty function
  const increaseQty = () => {
    if (!productInCart) {
      setQuantity(quantity + 1);
    } else {
      addToCart();
    }
    //todo:max stock check
  };

  const decreaseQty = () => {
    if (quantity - 1 < 1) {
      setQuantity(1);
    } else {
      cartContext.cartItemDecrement(product.id);
      setQuantity(quantity - 1);
    }
  };

  const addToCart = () => {
    let item = {
      id: product.id,
      title: product.title,
      slug: product.slug,
      order_time_price: finalPrice,
      image: getVariantImage(selectedVariant, product.variants),
      tax_rate: product.tax_rate,
      quantity: quantity,
      stock: selectedVariant.stock,
      product: product,
      variant: selectedVariant,
    };

    cartContext.addToCart(item);
  };

  useEffect(() => {
    if (user?.wishlist?.includes(product.id)) {
      setProductInWishlist(true);
    }
  }, [product, user]);

  const addToWishlist = () => {
    //TODO: Aut check
    if (!isAuthenticated) {
      openSignIn();
      return;
    }

    setProductInWishlist(true);
    // message.success('Product added to favorites!');

    let wishlist = user.wishlist;
    wishlist.push(product.id);
    let payload = {
      wishlist: wishlist,
    };
    axios
      .patch(`/users/update`, payload, { withCredentials: true })
      .then((response) => {});
  };

  const removeFromWishlist = () => {
    setProductInWishlist(false);
    // message.success('Product removed from favorites!');

    let wishlist = user.wishlist;
    let index = user.wishlist.indexOf(product.id);
    wishlist.splice(index, 1);

    let payload = {
      wishlist: wishlist,
    };
    axios
      .patch(`/users/update`, payload, { withCredentials: true })
      .then((response) => {});
  };

  const productImage = getVariantImage(selectedVariant, product.variants);

  return (
    <>
      <div className={styles.productCard}>
        <div>
          <div className={styles.productCard_top}>
            <div className={styles.fav_wrapper} style={{ cursor: "pointer" }}>
              {productInWishlist ? (
                <img
                  onClick={removeFromWishlist}
                  src={"/icon/wishlist-added.svg"}
                  alt="favorites"
                />
              ) : (
                <img
                  onClick={addToWishlist}
                  src={"/icon/wishlist.svg"}
                  alt="favorites"
                />
              )}
            </div>
          </div>
          <div className={styles.productCard_img}>
            {productImage ? (
              <img src={productImage} alt="product" />
            ) : (
              <div className={styles.no_image}>
                <CiImageOff fontSize="5rem" />
                <span className={styles.no_image_text}>
                  Image will be uploaded soon
                </span>
              </div>
            )}
            <div className={styles.nutri_score}>
              {product.nutri_score === "a" ? (
                <img
                  style={{ marginTop: 5, marginBottom: 10 }}
                  src={"/prod/nutri_a.png"}
                  alt="score_c"
                />
              ) : product.nutri_score === "b" ? (
                <img
                  style={{ marginTop: 5, marginBottom: 10 }}
                  src={"/prod/nutri_b.png"}
                  alt="score_c"
                />
              ) : product.nutri_score === "c" ? (
                <img
                  style={{ marginTop: 5, marginBottom: 10 }}
                  src={"/prod/nutri_c.png"}
                  alt="score_c"
                />
              ) : product.nutri_score === "d" ? (
                <img
                  style={{ marginTop: 5, marginBottom: 10 }}
                  src={"/prod/nutri_d.png"}
                  alt="score_c"
                />
              ) : (
                <img
                  style={{ marginTop: 5, marginBottom: 10 }}
                  src={"/prod/nutri_b.png"}
                  alt="score_c"
                />
              )}
            </div>
            <div className={styles.signs}>
              <img src="/icon/ps/bio.svg" alt="" />
              <img src="/icon/ps/new.svg" alt="" />
              <img src="/icon/ps/leaf.svg" alt="" />
            </div>
          </div>
        </div>

        <div style={{ flex: "1" }}>
          <Link to={`/products/${product.slug}`}>
            <div className={styles.productCard_name}>
              <div className={styles.productCard_name_text}>
                {product.title}
              </div>
              {/* <div className={styles.productCard_name_tag}>New</div> */}
            </div>
          </Link>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <span
              style={{
                fontSize: "2rem",
                fontWeight: "bold",
                color: "var(--color-primary)",
              }}
            >
              € {finalPrice}
            </span>
            {selectedVariant?.discount_percentage && (
              <span
                style={{
                  fontSize: "1.4rem",
                  color: "var(--color-red)",
                  textDecoration: "line-through",
                  marginLeft: ".5rem",
                  marginTop: ".5rem",
                }}
              >
                (
                {(finalPrice +
                  percentageCalculator(
                    selectedVariant?.price,
                    selectedVariant?.discount_percentage
                  )).toFixed(2)}
                €)
              </span>
            )}
          </div>

          <div className={styles.weight_info}>
            <span>({finalPrice.toFixed(2)}€/kg)</span>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            {selectedVariant && (
              <Select
                style={{ width: 80, marginTop: 10, color: "var(--color-dark)" }}
                defaultValue={selectedVariant.id}
                onChange={(value) => {
                  if (singleVariant) {
                    setSelectedVariant(selectedVariant);
                  } else {
                    variants.forEach((item) => {
                      if (item.id === value) {
                        setSelectedVariant(item);
                      }
                    });
                  }
                }}
              >
                {singleVariant ? (
                  <Select.Option value={selectedVariant.id}>
                    {selectedVariant.value}
                  </Select.Option>
                ) : (
                  variants.map((item, index) => {
                    return (
                      <Select.Option key={index} value={item.id}>
                        {item.value}
                      </Select.Option>
                    );
                  })
                )}
              </Select>
            )}
          </div>
          <div className={styles.productCard_actions}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginTop: 10 }}>
                <div
                  className={styles.productCard_actions_middle}
                  style={{ marginRight: "1rem" }}
                >
                  <BiMinus size={20} onClick={decreaseQty} />
                  <div className={styles.stock_amount}>{quantity}</div>
                  <BiPlus size={20} onClick={increaseQty} />
                </div>
                {!productInCart ? (
                  <div
                    className={styles.productCard_actions_right}
                    onClick={addToCart}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "var(--color-primary)",
                      width: "38px",
                      height: "38px",
                    }}
                  >
                    <img
                      src="/icon/cart.svg"
                      style={{ width: "28px", height: "28px" }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div
                    className={styles.productCard_actions_right}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "var(--color-primary)",
                      width: "38px",
                      height: "38px",
                    }}
                    onClick={() => {
                      cartContext.removeFromCart(product.id);
                    }}
                  >
                    <BsFillCartXFill size={20} color={"var(--color-light)"} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCardHorizontal;
